{
	"chooseName": "Choisir un nom!",
	"createNewAccount": "Créer un nouveau compte",
	"createSuggestedPlan": "Utiliser le plan comptable proposé",
	"delete": "Supprimer le plan comptable",
	"deleteBillPlanConfirmDialog": "Êtes-vous sûr de vouloir supprimer le compte ? \"{{name}}\"?",
	"deleteBillPlanSuccessNotification": "Compte {{name}} supprimé avec succès",
	"deleteConfirmDialog": "Êtes-vous sûr de vouloir supprimer le plan de comptable ?",
	"deleteSuccessNotification": "Plan comptable supprimé.",
	"downloadTemplate": "Télécharger le modèle de tableau",
	"editPlanOfAccountsSuccess": "Plan comptable édité avec succès.",
	"enter": "entrer",
	"errorNotification": "Échec du téléchargement du document {{name}}",
	"esc": "esc",
	"existingName": "Nom déjà existant",
	"export": "Exporter un tableau",
	"hasBillsMessage": "Ce compte est déjà associé à des transactions.",
	"importSuccessNotification": "Plan comptable importé avec succès.",
	"name": "Nom",
	"onChangeSuccessNotification": "Fichier {{name}} téléchargé avec succès",
	"parent": "Catégorie parent",
	"parentPlaceholder": "Sélectionner un nouveau parent...",
	"showTree": "Voir l'arbre du Plan comptable",
	"showTreeTitle": "Arbre du Plan comptable"
}
